import { cutToast } from 'utility/toast';
import React from 'react';
import { useMutation } from '@apollo/client';

import {
  CreateMessageData,
  CreateNewMessage,
} from 'common/components/CreateNewMessage';
import {
  MessageTravelerCreate,
  MessageTravelerCreateVariables,
} from './__generated__/MessageTravelerCreate';

import { PivotKeys } from 'common/components/MessagesSections';
import MESSAGE_TRAVELER_CREATE from './MessageTravelerCreate.graphql';
import TRAVELER_MESSAGES from '../TravelerMessages.graphql';
interface NewMessageProps {
  travelerID: string;
  selectedKey: string;
  onCreateMessage: () => void;
}

export const NewMessage: React.FC<NewMessageProps> = ({
  travelerID,
  selectedKey,
  onCreateMessage,
}) => {
  const [createMessage, { loading }] = useMutation<
    MessageTravelerCreate,
    MessageTravelerCreateVariables
  >(MESSAGE_TRAVELER_CREATE);

  const messageFilter =
    selectedKey === PivotKeys.sent
      ? { _isOutgoingMessage: { equalTo: true } }
      : { _isIncomingMessage: { equalTo: true } };

  const onSubmit = async (formData: CreateMessageData) => {
    const { messageComment, reminderDates, isResponseRequired, receivers } = {
      ...formData,
    };
    const { communicationChannel, department, user } = { ...receivers };
    const { errors } = await createMessage({
      variables: {
        input: {
          entityId: travelerID,
          message: { messageComment, reminderDates, isResponseRequired },
          communicationChannel,
          department,
          user,
        },
      },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: TRAVELER_MESSAGES,
          variables: {
            id: travelerID,
            first: 10,
            filter: messageFilter,
          },
        },
      ],
    });

    if (!errors) {
      onCreateMessage();
      cutToast.success('Message sent successfully.');
    } else cutToast.error(`${errors[0].message}`);
  };

  return <CreateNewMessage onSubmit={onSubmit} loading={loading} />;
};
